import React, { CSSProperties, useState } from "react";
import { Control, DeepMap, FieldError, Path } from "react-hook-form";
import { ToggleSwitch, ToggleSwitchProps } from "../buttons/ToggleSwitch/ToggleSwitch";
import { FormFieldError, FormFieldLayout } from "./FormFieldLayouts";
import { GenericControllerProvider, GenericControllerProviderProps } from "../forms/common/GenericControllerProvider";
import { StringIndexedDict } from "../../api/GenericTypes";

interface ToggleFieldProps<Entity extends StringIndexedDict> extends ToggleFormFieldProps<Entity> {
  value: boolean | null;
  onChange: (newValue?: boolean | null) => void;
  children?: React.ReactNode;
}
const ToggleField = <Entity extends StringIndexedDict>(props: ToggleFieldProps<Entity>) => {
  const fieldPath = props.id.split(".");
  let error: any = undefined;
  for (const path of fieldPath) {
    if (!error) error = props.errors?.[path];
    else error = error?.[path];
  }

  const [prevState, setPrevState] = useState<boolean>(props.value ?? false);

  if (props.uncontained) {
    return (
      <div
        className={`flex align-center justify-center`}
        style={{ width: "100%", height: "100%", ...props.wrapperContainerstyle }}
      >
        <ToggleSwitch
          checked={props.value}
          onToggle={() => {
            // props.onChange(props.allowIntermediate ? (props.value !== null ? null : !props.value) : !props.value);
            props.onChange(props.allowIntermediate ? (props.value !== null ? null : !prevState) : !props.value);
            setPrevState((ps) => (props.value !== null ? props.value : ps));
          }}
          toggleStyle={{ borderColor: error ? "var(--danger)" : "transparent" }}
          {...props}
        />
        {props.children ? (
          <div className="flex row-nowrap align-center gap-5" style={{ marginLeft: "auto" }}>
            {props.children}
          </div>
        ) : null}
        <FormFieldError id={props.id} errors={props.errors} />
      </div>
    );
  } else {
    return (
      <FormFieldLayout
        id={props.id}
        label={props.label}
        required={props.required}
        horizontal={props.horizontal}
        hasLabel={props.label !== ""}
      >
        <div
          className={`flex row-nowrap align-center gap-5 `}
          style={{ justifyContent: "flex-end", ...props.wrapperContainerstyle }}
        >
          <ToggleSwitch
            checked={props.value}
            onToggle={() => {
              // props.onChange(props.allowIntermediate ? (props.value !== null ? null : !props.value) : !props.value);
              props.onChange(props.allowIntermediate ? (props.value !== null ? null : !prevState) : !props.value);
              setPrevState((ps) => (props.value !== null ? props.value : ps));
            }}
            toggleStyle={{ borderColor: error ? "var(--danger)" : "transparent", marginTop: 0 }}
            {...props}
          />
          {props.children ? (
            <div className="flex row-nowrap align-center gap-5" style={{ marginLeft: "auto" }}>
              {props.children}
            </div>
          ) : null}
        </div>
        <FormFieldError id={props.id} errors={props.errors} />
      </FormFieldLayout>
    );
  }
};

export interface ToggleFormFieldProps<Entity extends StringIndexedDict> extends ToggleSwitchProps {
  id: Path<Entity>;
  control: Control<Entity>;
  label: string;
  errors?: DeepMap<any, FieldError>;
  required?: boolean;
  horizontal?: boolean;
  uncontained?: boolean;
  toggleControllerContainerStyle?: CSSProperties;
  wrapperContainerstyle?: CSSProperties;
  children?: React.ReactNode;
  controllerFieldOverride?: GenericControllerProviderProps<Entity>["controllerFieldOverride"];
  allowIntermediate?: boolean;
}
export const ToggleFormField = <Entity extends StringIndexedDict>(props: ToggleFormFieldProps<Entity>) => {
  return (
    <GenericControllerProvider<Entity>
      id={props.id}
      control={props.control}
      defaultValue={props.defaultValue}
      disabled={props.disabled}
      controllerFieldOverride={props.controllerFieldOverride}
    >
      {({ value, onChange }, fieldState, { errors }) => {
        return (
          <div style={{ whiteSpace: "nowrap", ...props.toggleControllerContainerStyle }}>
            <ToggleField {...props} value={value} onChange={onChange} children={props.children} />
          </div>
        );
      }}
    </GenericControllerProvider>
  );
  // return (
  //   <>
  //     <Controller
  //       control={props.control}
  //       name={props.id}
  //       render={({ field: { onChange, value } }) => (
  //         <div style={{ whiteSpace: "nowrap", ...props.toggleControllerContainerStyle }}>
  //           <ToggleField {...props} value={value} onChange={onChange} children={props.children} />
  //         </div>
  //       )}
  //     />
  //   </>
  // );
};
